import PropTypes from 'prop-types';
import { Row, Col } from 'react-bootstrap';
import useBrowserSize from '../../hooks/browser-size';

const Packages = (props) => {
  const showPackages = props.packages !== undefined && props.packages.length > 1;
  const packages = [];

  const [, screenSize] = useBrowserSize();
  const isDesktop = ['md', 'lg', 'xl'].includes(screenSize);

  if (showPackages) {
    packages.push(
      props.packages.map((p, idx) => (
        <>
          <Col
            as="li"
            key={idx}
            className={`${idx !== 0 && isDesktop && 'border-start'} border-grey`}>
            <p>{p.name}</p>
            <p>
              {p.price} {p.availability == 'Sold Out' && <span>Sold Out</span>}
            </p>

            {p.capacity > 0 && <p>Capacity: {p.capacity}</p>}
            {p.description.length > 0 && <p>{p.description}</p>}
          </Col>
        </>
      ))
    );
  }

  return (
    <>
      {props.packages !== undefined && props.packages.length > 1 && (
        <div className="mt-5">
          <h2 className="border-bottom border-grey py-2">Event Pricing</h2>
          <Row as="ul" className="row-cols-md-3 row-cols-auto list-unstyled">
            {packages}
          </Row>
        </div>
      )}
    </>
  );
};

export default Packages;

Packages.propTypes = {
  packages: PropTypes.array.isRequired
};
